import platform$1 from "./browser/index.mjs";
import * as utils from "./common/utils.mjs";
const platform = {
  ...utils,
  ...platform$1
};
export {
  platform as default
};
